import type { GoldenCase, GoldenRubric } from "@/services/adminModelCurrency";
import { renderMarkdown } from "@/utils/markdown";

const asList = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((v): v is string => typeof v === "string") : [];

const RubricList = ({ title, items }: { title: string; items: string[] }) =>
  items.length ? (
    <div>
      <h4 className="text-xs font-medium">{title}</h4>
      <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
        {items.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  ) : null;

const RubricView = ({ rubric }: { rubric: string | GoldenRubric }) =>
  typeof rubric === "string" ? (
    <p className="whitespace-pre-wrap text-sm text-muted-foreground">{rubric}</p>
  ) : (
    <div className="space-y-2">
      <RubricList title="Must have" items={asList(rubric.mustHave)} />
      <RubricList title="Should have" items={asList(rubric.shouldHave)} />
    </div>
  );

const TranscriptView = ({ goldenCase }: { goldenCase: GoldenCase }) => (
  <div className="space-y-3">
    <section>
      <h3 className="text-xs font-semibold uppercase text-muted-foreground">Question</h3>
      <p className="whitespace-pre-wrap rounded-md bg-muted p-3 text-sm">{goldenCase.question}</p>
    </section>
    <section>
      <h3 className="text-xs font-semibold uppercase text-muted-foreground">Assistant response</h3>
      <div
        className="chat-prose rounded-md border p-3 text-sm [&_.school-star]:hidden"
        onClick={e => {
          // Labeling is read-only: links in the saved answer must not navigate away.
          if ((e.target as HTMLElement).closest("a, button")) e.preventDefault();
        }}
        dangerouslySetInnerHTML={{ __html: renderMarkdown(goldenCase.response) }}
      />
    </section>
    {goldenCase.rubric ? (
      <section>
        <h3 className="text-xs font-semibold uppercase text-muted-foreground">
          What a good answer looks like
        </h3>
        <RubricView rubric={goldenCase.rubric} />
      </section>
    ) : null}
  </div>
);

export default TranscriptView;
